import { StyleSheet } from 'react-native'
import { DS } from '../../design-system'
import { TouchableOpacity } from '@gorhom/bottom-sheet'

export const numberDayToLetterDayMap: Record<number, string> = {
  0: 'S',
  1: 'M',
  2: 'T',
  3: 'W',
  4: 'T',
  5: 'F',
  6: 'S'
}

export const numberDayToStringDayMap: Record<number, string> = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
}

export const NotificationDay = ({
  day,
  isSelected,
  onPress
}: {
  day: string
  isSelected: boolean
  onPress: (day: number) => void
}) => {
  const dayNumber = parseInt(day)
  return (
    <TouchableOpacity onPress={() => onPress(dayNumber)}>
      <DS.Frame
        style={styles.container}
        justifyContent="center"
        alignItems="center"
        bg={isSelected ? 'Brand/Maroon' : 'Global/White'}
      >
        <DS.Text
          variant="Body Medium/Medium"
          color={isSelected ? 'Global/White' : 'Global/Black'}
          style={{ textAlign: 'center' }}
        >
          {numberDayToLetterDayMap[dayNumber]}
        </DS.Text>
      </DS.Frame>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 32,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    width: 40,
    height: 32
  }
})
